/* tslint:disable */
/* eslint-disable */
export enum WorkInteractionRelationTypeEnum {
  Contacts = 'Contacts',
  Debtors = 'Debtors',
  Projects = 'Projects',
  Prospects = 'Prospects',
  Tasks = 'Tasks',
  Tickets = 'Tickets'
}
